"use client";

import packageJson from "../package.json" with { type: "json" };

// Two layers, two truths:
//   Data plane — indexed pool/price data, sourced from Stellar Mainnet.
//   Protocol plane — Hoops smart contracts, currently deployed on Testnet.
// Lumping both under one "STELLAR · TESTNET" label was misleading for
// institutional viewers who saw "testnet" and assumed the data was fake too.
const DATA_NETWORK = process.env.NEXT_PUBLIC_STELLAR_NETWORK === "testnet" ? "TESTNET" : "MAINNET";
const PROTOCOL_NETWORK = process.env.NEXT_PUBLIC_PROTOCOL_NETWORK === "mainnet" ? "MAINNET" : "TESTNET";

const APP_VERSION = packageJson.version;

export function StatusBar() {
  return (
    <footer
      className="fixed bottom-0 inset-x-0 z-30 h-7 flex items-center justify-between gap-4 px-7 max-[900px]:px-5 max-[600px]:px-3.5"
      style={{
        background: "rgba(6,6,6,0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderTop: "1px solid var(--border-subtle)",
      }}
      aria-label="Status bar"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span
          className="text-[10px] tracking-[0.18em] uppercase"
          style={{ color: "var(--text-secondary)" }}
        >
          STELLAR
        </span>
        <Indicator label="Data" network={DATA_NETWORK} tone={DATA_NETWORK === "MAINNET" ? "green" : "yellow"} />
        <Indicator label="Protocol" network={PROTOCOL_NETWORK} tone={PROTOCOL_NETWORK === "MAINNET" ? "green" : "yellow"} />
      </div>
      <span
        className="text-[10px] tracking-[0.12em] uppercase hidden sm:inline whitespace-nowrap"
        style={{ color: "var(--text-tertiary)" }}
      >
        HOOPS FINANCE · v{APP_VERSION}
      </span>
    </footer>
  );
}

function Indicator({ label, network, tone }: { label: string; network: string; tone: "green" | "yellow" }) {
  const dotColor = tone === "green" ? "var(--green, #4ade80)" : "#e0a052";
  const dotShadow =
    tone === "green"
      ? "0 0 6px rgba(74,222,128,0.55)"
      : "0 0 6px rgba(224,160,82,0.55)";
  return (
    <span className="flex items-center gap-1.5">
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: dotColor, boxShadow: dotShadow }}
        aria-hidden="true"
      />
      <span
        className="text-[10px] tracking-[0.14em] uppercase"
        style={{ color: "var(--text-secondary)" }}
      >
        {label} · <span style={{ color: tone === "green" ? "var(--text-primary)" : "#e0a052" }}>{network}</span>
      </span>
    </span>
  );
}
